import React from 'react';
import TipoClienteForm from './TipoClienteForm';
import TipoClienteDetails from './TipoClienteDetails';
import './TipoClienteModal.css';

const TipoClienteModal = ({ 
  isOpen, 
  onClose, 
  tipoCliente, 
  showForm,
  isEditing, 
  onEdit,
  onDelete,
  onSubmit,
  onCancel 
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains('modal-backdrop')) {
      onClose();
    }
  };

  // Get user role from localStorage
  const userType = localStorage.getItem('userType') || '';
  const isMaster = userType === 'master';

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>
            {showForm 
              ? (isEditing ? 'Editar Tipo de Cliente' : 'Cadastrar Tipo de Cliente')
              : 'Detalhes do Tipo de Cliente'}
          </h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          {showForm ? (
            <TipoClienteForm
              tipoCliente={isEditing ? tipoCliente : null}
              isEditing={isEditing}
              onSubmit={onSubmit}
              onCancel={onCancel}
            />
          ) : tipoCliente ? (
            <TipoClienteDetails
              tipoCliente={tipoCliente}
            />
          ) : (
            <div className="modal-placeholder">
              Nenhum tipo de cliente selecionado
            </div>
          )}
        </div>
        
        {/* Footer for details view */}
        {!showForm && tipoCliente && (
          <div className="modal-footer">
            <button 
              className="clientes-btn clientes-btn-outline"
              onClick={onEdit}
            >
              <i className="fas fa-edit"></i>
              Editar
            </button>
            
            {isMaster && (
              <button 
                className="clientes-btn clientes-btn-secondary"
                onClick={onDelete}
                style={{ backgroundColor: '#ff4d4f', color: 'white', border: 'none' }}
              >
                <i className="fas fa-trash-alt"></i>
                Excluir
              </button>
            )}
            
            <button 
              className="clientes-btn clientes-btn-secondary"
              onClick={onClose}
              style={{ backgroundColor: '#3E5F56', color: 'white' }}
            >
              <i className="fas fa-times"></i>
              Fechar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TipoClienteModal;
